

import html2pdf from 'html2pdf.js';

const generateSalarySlipPDF = (slip, user = {}) => {
  console.log(slip)
  const fullName = slip.full_name || user.full_name || 'N/A';
  const empId = slip.emp_id || user.employee_id || 'N/A';
  const dept = slip.department || user.department || 'N/A';
  const position = slip.position || user.position || 'N/A';
  const date = new Date(slip.generated_date).toLocaleDateString('en-IN');
  const payPeriod = new Date(2023, slip.month - 1).toLocaleDateString('en-IN', { month: 'long' }) + ' ' + slip.year;
  const netPayWords = convertNumberToWords(slip.net_salary);
  const currency = '₹';

  const element = document.createElement('div');
  element.innerHTML = `
    <div style="font-family: 'Poppins', sans-serif; padding: 40px; max-width: 800px; margin: auto; border: 2px solid #2e86de; box-shadow: 0 0 15px rgba(0,0,0,0.15);">
      <div style="text-align: center; margin-bottom: 24px;">
        <h1 style="margin: 0; font-size: 26px; color: #2e86de;">Shubham Infotech</h1>
        <p style="font-size: 13px; color: #2c3e50;">
          2nd Floor, Bhadauriya House, Gandhi Nagar, Ganeshdham Extension,<br/> Sundarpur, Newada, Varanasi, Uttar Pradesh 221005
        </p>
        <h2 style="margin-top: 16px; font-size: 20px; color: #34495e;">Salary Slip</h2>
      </div>

      <table style="width: 100%; font-size: 14px; margin-bottom: 24px;">
        <tr>
          <td><strong>Employee Name:</strong> ${fullName}</td>
          <td><strong>Employee ID:</strong> ${empId}</td>
        </tr>
        <tr>
          <td><strong>Department:</strong> ${dept}</td>
          <td><strong>Designation:</strong> ${position}</td>
        </tr>
        <tr>
          <td><strong>Pay Period:</strong> ${payPeriod}</td>
        </tr>
      </table>

      <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
        <thead>
          <tr style="background: #f0f3f8;">
            <th style="padding: 8px; border: 1px solid #ccc;">Earnings</th>
            <th style="padding: 8px; border: 1px solid #ccc; text-align: right;">Amount (${currency})</th>
            <th style="padding: 8px; border: 1px solid #ccc;">Deductions</th>
            <th style="padding: 8px; border: 1px solid #ccc; text-align: right;">Amount (${currency})</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="padding: 8px; border: 1px solid #ccc;">Basic Salary</td>
           <td style="padding: 8px; border: 1px solid #ccc; text-align: right;">${Number(slip.basic_salary).toFixed(2)}</td>
            <td style="padding: 8px; border: 1px solid #ccc;">Deductions</td>
            <td style="text-align: right;">${currency}${(
        ((Number(slip.basic_salary) + Number(slip.allowances) - Number(slip.deductions)) - Number(slip.net_salary)) 
        + Number(slip.deductions)
      ).toFixed(2)}</td>
          </tr>
          <tr>
            <td style="padding: 8px; border: 1px solid #ccc;">Allowances</td>
            <td style="padding: 8px; border: 1px solid #ccc; text-align: right;">${Number(slip.allowances).toFixed(2)}</td>
            <td style="padding: 8px; border: 1px solid #ccc;">Overtime (${slip.overtime_hours} hrs)</td>
            <td style="padding: 8px; border: 1px solid #ccc; text-align: right;">
             ${((Number(slip.basic_salary) / (Number(slip.total_days) * 8)) * Number(slip.overtime_hours)).toFixed(2)}
            </td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top: 24px;">
        <table style="width: 100%; font-size: 14px;">
          <tr><td><strong>Total Earnings:</strong></td><td style="text-align:right;">${currency}${(Number(slip.basic_salary) + Number(slip.allowances)).toFixed(2)}</td></tr>
          <tr><td><strong>Total Deductions:</strong></td><td style="text-align:right;">      ${currency}${(
        ((Number(slip.basic_salary) + Number(slip.allowances) - Number(slip.deductions)) - Number(slip.net_salary)) 
        + Number(slip.deductions)
      ).toFixed(2)}</td></tr>
          <tr style="font-size: 16px; font-weight: bold; color: green;">
            <td><strong>Net Pay:</strong></td><td style="text-align:right;">${currency}${Number(slip.net_salary).toFixed(2)}</td>
          </tr>
        </table>
        <p style="margin-top: 10px;"><strong>In Words:</strong> ${netPayWords} only</p>
      </div>

      <div style="margin-top: 40px; display: flex; justify-content: space-between; font-size: 13px;">
        <div style="text-align: center;">___________________<br />Authorized Signatory</div>
        <div style="text-align: center;">___________________<br />Employee Signature</div>
      </div>

      <p style="text-align: center; font-size: 11px; color: gray; margin-top: 30px;">
        This is a computer-generated document and does not require a physical signature.
      </p>
    </div>
  `;

  html2pdf().from(element).set({
    margin: 10,
    filename: `SalarySlip_${empId}_${slip.month}_${slip.year}.pdf`,
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  }).save();
};

function convertNumberToWords(num) {
  const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
    'Seventeen', 'Eighteen', 'Nineteen'];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  if (num === 0) return 'Zero';

  function inWords(n) {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
    if (n < 1000) return a[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' and ' + inWords(n % 100) : '');
    if (n < 100000) return inWords(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' ' + inWords(n % 1000) : '');
    return 'Amount too large';
  }

  return inWords(Math.floor(num));
}

export default generateSalarySlipPDF;

